// extracted by mini-css-extract-plugin
module.exports = {"title":"NotesModal_title__EdutU","label":"NotesModal_label__SeLEY"};